import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { NavigationService } from '../../services/navigation.service';
import { User, UserService } from '../../services/user.service';
import { environment } from '../../../../environments/environment';
import { getExceptionMessage } from '../../../shared/functions/get-exception-message';
import { LoginService } from '../../services/login.service';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hfc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public form: UntypedFormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  public isSubmitting = false;
  public message: string;
  public isRegisteredUser = false;
  public adminWebUrl = environment.adminWebUrl;
  public today = new Date();

  constructor(
    public readonly tenantConfigService: TenantConfigService,
    private fb: UntypedFormBuilder,
    private navigationService: NavigationService,
    private userService: UserService,
    private authService: AuthService,
    private loginService: LoginService
  ) {}

  public onForgotClicked() {
    this.navigationService.goToForgotPassword();
  }

  public async onSubmit() {
    const data = this.form.value;

    try {
      this.isSubmitting = true;

      const user = (await this.authService.checkLogin(data)) as User;

      if (user.userType !== 'CLIENT' && user.userType) {
        this.isRegisteredUser = true;

        return;
      }

      this.userService.setUser(user);
      await this.loginService.login(data, user);
    } catch (e) {
      console.log('Error calling login API: ', e);
      this.message = getExceptionMessage(e);
    } finally {
      this.isSubmitting = false;
    }
  }
}
